import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableSurveyFidusia } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import LogoPerusahaanSpFidusiaBlackAndWhite from "../../../assets/LogoPerusahaanSpFidusiaBlackAndWhite.jpg";
import { Colors } from "../../../constants/styles";
import { Container, Form, Row, Col, Card, InputGroup } from "react-bootstrap";
import {
  Box,
  Pagination,
  Button,
  ButtonGroup,
  Paper,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Chip,
  CardHeader,
  CardActionArea,
  CardMedia,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { useDownloadExcel } from "react-export-table-to-excel";
import firebase from "firebase/compat/app";
import Carousel from "react-elastic-carousel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PanoramaIcon from "@mui/icons-material/Panorama";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilSurveyFidusia = () => {
  const ref = useRef(null);
  const tableRef = useRef(null);
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const screenSize = useScreenWidth();

  const [isFetchError, setIsFetchError] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [registerFidusiaId, setRegisterFidusiaId] = useState("");
  const [cif, setCif] = useState("");
  const [nikCustomer, setNikCustomer] = useState("");
  const [noKkCustomer, setNoKkCustomer] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [namaPanggilanCustomer, setNamaPanggilanCustomer] = useState("");
  const [tempatLahirCustomer, setTempatLahirCustomer] = useState("");
  const [tanggalLahirCustomer, setTanggalLahirCustomer] = useState("");
  const [jenisKelaminCustomer, setJenisKelaminCustomer] = useState("");
  const [agamaCustomer, setAgamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [alamatCustomer, setAlamatCustomer] = useState("");
  const [alamatTTCustomer, setAlamatTTCustomer] = useState("");
  const [kodeProvinsi, setKodeProvinsi] = useState("");
  const [kodeProvinsiTT, setKodeProvinsiTT] = useState("");
  const [kodeKabupaten, setKodeKabupaten] = useState("");
  const [kodeKabupatenTT, setKodeKabupatenTT] = useState("");
  const [kodeKecamatan, setKodeKecamatan] = useState("");
  const [kodeKecamatanTT, setKodeKecamatanTT] = useState("");
  const [kodeKelurahan, setKodeKelurahan] = useState("");
  const [kodeKelurahanTT, setKodeKelurahanTT] = useState("");
  const [kodePos, setKodePos] = useState("");
  const [kodePosTT, setKodePosTT] = useState("");
  const [statusPerkawinanCustomer, setStatusPerkawinanCustomer] = useState("");
  const [pekerjaanCustomer, setPekerjaanCustomer] = useState("");
  const [kewarganegaraanCustomer, setKewarganegaraanCustomer] = useState("");

  const [namaPerusahaanCustomer, setNamaPerusahaanCustomer] = useState("");
  const [bidangUsahaCustomer, setBidangUsahaCustomer] = useState("");
  const [jabatanCustomer, setJabatanCustomer] = useState("");
  const [alamatPerusahaanCustomer, setAlamatPerusahaanCustomer] = useState("");
  const [noTeleponPerusahaanCustomer, setNoTeleponPerusahaanCustomer] =
    useState("");
  const [lamaKerjaCustomer, setLamaKerjaCustomer] = useState("");
  const [gajiPekerjaanCustomer, setGajiPekerjaanCustomer] = useState("0");
  const [pendapatanLainCustomer, setPendapatanLainCustomer] = useState("0");

  // Data Penjamin
  const [nikPenjamin, setNikPenjamin] = useState("");
  const [noKkPenjamin, setNoKkPenjamin] = useState("");
  const [namaPenjamin, setNamaPenjamin] = useState("");
  const [tempatLahirPenjamin, setTempatLahirPenjamin] = useState("");
  const [tanggalLahirPenjamin, setTanggalLahirPenjamin] = useState(new Date());
  const [jenisKelaminPenjamin, setJenisKelaminPenjamin] = useState("");
  const [agamaPenjamin, setAgamaPenjamin] = useState("");
  const [noTeleponPenjamin, setNoTeleponPenjamin] = useState("");
  const [alamatPenjamin, setAlamatPenjamin] = useState("");
  const [kodeProvinsiPenjamin, setKodeProvinsiPenjamin] = useState("");
  const [kodeKabupatenPenjamin, setKodeKabupatenPenjamin] = useState("");
  const [kodeKecamatanPenjamin, setKodeKecamatanPenjamin] = useState("");
  const [kodeKelurahanPenjamin, setKodeKelurahanPenjamin] = useState("");
  const [kodePosPenjamin, setKodePosPenjamin] = useState("");
  const [statusPerkawinanPenjamin, setStatusPerkawinanPenjamin] = useState("");
  const [namaPerusahaanPenjamin, setNamaPerusahaanPenjamin] = useState("");
  const [alamatPerusahaanPenjamin, setAlamatPerusahaanPenjamin] = useState("");
  const [pekerjaanPenjamin, setPekerjaanPenjamin] = useState("");
  const [lamaKerjaPenjamin, setLamaKerjaPenjamin] = useState("");
  const [kewarganegaraanPenjamin, setKewarganegaraanPenjamin] = useState("");
  const [hubunganPenjamin, setHubunganPenjamin] = useState("");

  const [alamatSamaPenjamin, setAlamatSamaPenjamin] = useState(false);
  const [alamatTTPenjamin, setAlamatTTPenjamin] = useState("");
  const [kodeProvinsiTTPenjamin, setKodeProvinsiTTPenjamin] = useState("");
  const [kodeKabupatenTTPenjamin, setKodeKabupatenTTPenjamin] = useState("");
  const [kodeKecamatanTTPenjamin, setKodeKecamatanTTPenjamin] = useState("");
  const [kodeKelurahanTTPenjamin, setKodeKelurahanTTPenjamin] = useState("");
  const [kodePosTTPenjamin, setKodePosTTPenjamin] = useState("");

  const [uangMuka, setUangMuka] = useState("");
  const [pinjamanAju, setPinjamanAju] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [tenor, setTenor] = useState("");

  // DATA KENDARAAN
  const [merk, setMerk] = useState("");
  const [tipe, setTipe] = useState("");
  const [tahun, setTahun] = useState("");
  const [warna, setWarna] = useState("");
  const [isi, setIsi] = useState("");
  const [nopol, setNopol] = useState("");
  const [noRangka, setNoRangka] = useState("");
  const [noMesin, setNoMesin] = useState("");
  const [tglStnk, setTglStnk] = useState("");
  const [noBpkb, setNoBpkb] = useState("");
  const [bpkbAN, setBpkbAN] = useState("");
  const [bpkbAlamat, setBpkbAlamat] = useState("");

  const [linkMapsSurvey, setLinkMapsSurvey] = useState("");

  // DATA REFERENSI
  const [namaRefRegister, setNamaRefRegister] = useState("");
  const [alamatRefRegister, setAlamatRefRegister] = useState("");
  const [teleponRefRegister, setTeleponRefRegister] = useState("");
  const [hubunganRefRegister, setHubunganRefRegister] = useState("");
  // const [statusPerkawinanRefRegister, setStatusPerkawinanRefRegister] =
  //   useState("");
  const [namaRef2Register, setNamaRef2Register] = useState("");
  const [alamatRef2Register, setAlamatRef2Register] = useState("");
  const [teleponRef2Register, setTeleponRef2Register] = useState("");
  const [hubunganRef2Register, setHubunganRef2Register] = useState("");
  // const [statusPerkawinanRef2Register, setStatusPerkawinanRef2Register] =
  //   useState("");
  const [namaRef3Register, setNamaRef3Register] = useState("");
  const [alamatRef3Register, setAlamatRef3Register] = useState("");
  const [teleponRef3Register, setTeleponRef3Register] = useState("");
  const [hubunganRef3Register, setHubunganRef3Register] = useState("");
  // const [statusPerkawinanRef3Register, setStatusPerkawinanRef3Register] =
  //   useState("");

  // DATA PINJAMAN
  const [hargaOtr, setHargaOtr] = useState("");
  const [tglJtTempo, setTglJtTempo] = useState(null);
  const [tujuanPenggunaanDana, setTujuanPenggunaanDana] = useState("");
  const [pendinganPengurusan, setPendinganPengurusan] = useState("");
  const [kodeMarketing, setKodeMarketing] = useState("");
  const [kodeSurveyor, setKodeSurveyor] = useState("");

  const [keteranganSurvey, setKeteranganSurvey] = useState(
    "Saya menyatakan benar dan akurat atas seluruh informasi dan atau dokumen yang saya berikan kepada PT Sistem Gadai. Apabila ternyata dikemudian hari informasi tersebut tidak benar, saya bersedia mempertanggungjawabkannya, dan sanggup menaati segala peraturan perjanjian yang telah ditetapkan oleh perusahaan. Tujuan setiap setoran dana bukanlah berasal dari Tindak Pidana Pencucian Uang dan tujuan Pinjaman dana bukan bertujuan untuk kaitanya Tindak Pidana Pencucian Uang, Tindak Pidana Pendanaan Terorisme maupun Pendanaan Proliferasi Senjata Pemusnah Masal. Apabila di kemudian hari terbukti melakukan tujuan tujuan tersebut maka saya bersedia tunduk pada peraturan perundang-undangan yang berlaku."
  );
  const [keterangan, setKeterangan] = useState("");

  const [denahLokasiSurvey, setDenahLokasiSurvey] = useState("");
  const [ttdSurvey, setTtdSurvey] = useState("");
  const [namaTtdSurvey, setNamaTtdSurvey] = useState("");

  const [statusSurvey, setStatusSurvey] = useState("");
  const [tglRejectSurvey, setTglRejectSurvey] = useState(new Date());
  const [alasanRejectSurvey, setAlasanRejectSurvey] = useState("");
  const [isReject, setIsReject] = useState(false);
  const [alasanPendingSurvey, setAlasanPendingSurvey] = useState("");
  const [isPending, setIsPending] = useState(false);

  const [statusSurveyManager, setStatusSurveyManager] = useState("");

  const [error, setError] = useState(false);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [previewPdfFormulir, setPreviewPdfFormulir] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [surveyFidusias, setSurveyFidusias] = useState([]);
  const [surveyFidusiasPagination, setSurveyFidusiasPagination] = useState([]);
  let [gambar, setGambar] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [open, setOpen] = useState(false);

  const [filter, setFilter] = useState("SEMUA");

  const handleChangeFilter = (event) => {
    setFilter(event.target.value);
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getSurveyFidusiasPagination();
    id && getSurveyFidusiaById();
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [id, page, searchTerm, filter]);

  const getSurveyFidusiasPagination = async () => {
    setLoading(true);
    try {
      if (user.tipeUser === "MARKETING") {
        const response = await axios.post(
          `${tempUrl}/surveyFidusiasPerCabangKodeMarketingPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            filter,
            marketingId: user.marketingId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSurveyFidusiasPagination(response.data.surveyFidusias);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
      } else if (user.tipeUser === "SURVEYOR") {
        const response = await axios.post(
          `${tempUrl}/surveyFidusiasPerCabangKodeSurveyorPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            filter,
            surveyorId: user.surveyorId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSurveyFidusiasPagination(response.data.surveyFidusias);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
      } else {
        const response = await axios.post(
          `${tempUrl}/surveyFidusiasPerCabangPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            filter,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSurveyFidusiasPagination(response.data.surveyFidusias);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
      }
    } catch (error) {
      console.log(error);
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getSurveyFidusias = async (pdf, excel) => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/surveyFidusiasPerCabang`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setSurveyFidusias(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }

    if (excel) {
      const response = await axios.post(
        `${tempUrl}/surveyFidusiasPerCabangForDoc`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      downloadExcel(response.data);
    }

    setLoading(false);
  };

  const getSurveyFidusiaById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/surveyFidusias/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setCustomerId(response.data.registerfidusia.customer.id);
      setRegisterFidusiaId(response.data.registerfidusia.id);
      setCif(response.data.registerfidusia.customer.cifCustomer);
      setNikCustomer(response.data.registerfidusia.customer.nikCustomer);
      setNoKkCustomer(response.data.registerfidusia.customer.noKkCustomer);
      setNamaCustomer(response.data.registerfidusia.customer.namaCustomer);
      setNamaPanggilanCustomer(
        response.data.registerfidusia.customer.namaPanggilanCustomer
      );
      setTempatLahirCustomer(
        response.data.registerfidusia.customer.tempatLahirCustomer
      );
      setTanggalLahirCustomer(
        formatDate(response.data.registerfidusia.customer.tanggalLahirCustomer)
      );
      setJenisKelaminCustomer(
        response.data.registerfidusia.customer.jenisKelaminCustomer
      );
      setAgamaCustomer(response.data.registerfidusia.customer.agamaCustomer);
      setNoTeleponCustomer(
        response.data.registerfidusia.customer.noTeleponCustomer
      );
      setAlamatCustomer(response.data.registerfidusia.customer.alamatCustomer);
      setAlamatTTCustomer(
        response.data.registerfidusia.customer.alamatTTCustomer
      );
      setKodeProvinsi(
        response.data.registerfidusia.customer.provinsis.namaProvinsi
      );
      setKodeProvinsiTT(
        response.data.registerfidusia.customer.provinsisTT.namaProvinsi
      );
      setKodeKabupaten(
        response.data.registerfidusia.customer.kabupaten.namaKabupaten
      );
      setKodeKabupatenTT(
        response.data.registerfidusia.customer.kabupatenTT.namaKabupaten
      );
      setKodeKecamatan(
        response.data.registerfidusia.customer.kecamatan.namaKecamatan
      );
      setKodeKecamatanTT(
        response.data.registerfidusia.customer.kecamatanTT.namaKecamatan
      );
      setKodeKelurahan(
        response.data.registerfidusia.customer.kelurahan.namaKelurahan
      );
      setKodeKelurahanTT(
        response.data.registerfidusia.customer.kelurahanTT.namaKelurahan
      );
      setKodePos(response.data.registerfidusia.customer.kelurahan.kodePos);
      setKodePosTT(response.data.registerfidusia.customer.kelurahanTT.kodePos);
      setStatusPerkawinanCustomer(
        response.data.registerfidusia.customer.statusPerkawinanCustomer
      );
      setPekerjaanCustomer(
        response.data.registerfidusia.customer.pekerjaanCustomer
      );
      setKewarganegaraanCustomer(
        response.data.registerfidusia.customer.kewarganegaraanCustomer
      );

      setNamaPerusahaanCustomer(
        response.data.registerfidusia.customer.namaPerusahaanCustomer
      );
      setBidangUsahaCustomer(
        response.data.registerfidusia.customer.bidangUsahaCustomer
      );
      setJabatanCustomer(
        response.data.registerfidusia.customer.jabatanCustomer
      );
      setAlamatPerusahaanCustomer(
        response.data.registerfidusia.customer.alamatPerusahaanCustomer
      );
      setNoTeleponPerusahaanCustomer(
        response.data.registerfidusia.customer.noTeleponPerusahaanCustomer
      );
      setLamaKerjaCustomer(
        response.data.registerfidusia.customer.lamaKerjaCustomer
      );
      setGajiPekerjaanCustomer(
        response.data.registerfidusia.customer.gajiPekerjaanCustomer
      );
      setPendapatanLainCustomer(
        response.data.registerfidusia.customer.pendapatanLainCustomer
      );

      setNikPenjamin(response.data.registerfidusia.nikPenjamin);
      setNoKkPenjamin(response.data.registerfidusia.noKkPenjamin);
      setNamaPenjamin(response.data.registerfidusia.namaPenjamin);
      setTempatLahirPenjamin(response.data.registerfidusia.tempatLahirPenjamin);
      setTanggalLahirPenjamin(
        response.data.registerfidusia.tanggalLahirPenjamin &&
          formatDate(response.data.registerfidusia.tanggalLahirPenjamin)
      );
      setJenisKelaminPenjamin(
        response.data.registerfidusia.jenisKelaminPenjamin
      );
      setAgamaPenjamin(response.data.registerfidusia.agamaPenjamin);
      setNoTeleponPenjamin(response.data.registerfidusia.noTeleponPenjamin);
      setAlamatPenjamin(response.data.registerfidusia.alamatPenjamin);
      setKodeProvinsiPenjamin(
        response.data.registerfidusia.provinsisPenjamin &&
          response.data.registerfidusia.provinsisPenjamin.namaProvinsi
      );
      setKodeKabupatenPenjamin(
        response.data.registerfidusia.kabupatenPenjamin &&
          response.data.registerfidusia.kabupatenPenjamin.namaKabupaten
      );
      setKodeKecamatanPenjamin(
        response.data.registerfidusia.kecamatanPenjamin &&
          response.data.registerfidusia.kecamatanPenjamin.namaKecamatan
      );
      setKodeKelurahanPenjamin(
        response.data.registerfidusia.kelurahanPenjamin &&
          response.data.registerfidusia.kelurahanPenjamin.namaKelurahan
      );
      setKodePosPenjamin(
        response.data.registerfidusia.kelurahanPenjamin &&
          response.data.registerfidusia.kelurahanPenjamin.kodePos
      );
      setStatusPerkawinanPenjamin(
        response.data.registerfidusia.statusPerkawinanPenjamin
      );
      setNamaPerusahaanPenjamin(
        response.data.registerfidusia.namaPerusahaanPenjamin
      );
      setAlamatPerusahaanPenjamin(
        response.data.registerfidusia.alamatPerusahaanPenjamin
      );
      setPekerjaanPenjamin(response.data.registerfidusia.pekerjaanPenjamin);
      setLamaKerjaPenjamin(response.data.registerfidusia.lamaKerjaPenjamin);
      setKewarganegaraanPenjamin(
        response.data.registerfidusia.kewarganegaraanPenjamin
      );
      setHubunganPenjamin(response.data.registerfidusia.hubunganPenjamin);

      setAlamatSamaPenjamin(response.data.registerfidusia.alamatSamaPenjamin);
      setAlamatTTPenjamin(response.data.registerfidusia.alamatTTPenjamin);
      setKodeProvinsiTTPenjamin(
        response.data.registerfidusia.provinsisTTPenjamin &&
          response.data.registerfidusia.provinsisTTPenjamin.namaProvinsi
      );
      setKodeKabupatenTTPenjamin(
        response.data.registerfidusia.kabupatenTTPenjamin &&
          response.data.registerfidusia.kabupatenTTPenjamin.namaKabupaten
      );
      setKodeKecamatanTTPenjamin(
        response.data.registerfidusia.kecamatanTTPenjamin &&
          response.data.registerfidusia.kecamatanTTPenjamin.namaKecamatan
      );
      setKodeKelurahanTTPenjamin(
        response.data.registerfidusia.kelurahanTTPenjamin &&
          response.data.registerfidusia.kelurahanTTPenjamin.namaKelurahan
      );
      setKodePosTTPenjamin(
        response.data.registerfidusia.kelurahanTTPenjamin &&
          response.data.registerfidusia.kelurahanTTPenjamin.kodePos
      );

      setUangMuka(response.data.registerfidusia.uangMuka);
      setPinjamanAju(response.data.registerfidusia.pinjamanAju);
      setAngPerBulan(response.data.registerfidusia.angPerBulan);
      setTenor(response.data.registerfidusia.tenor);

      // DATA KENDARAAN
      setMerk(response.data.merk);
      setTipe(response.data.tipe);
      setTahun(response.data.tahun);
      setWarna(response.data.warna);
      setIsi(response.data.isi);
      setNopol(response.data.nopol);
      setNoRangka(response.data.noRangka);
      setNoMesin(response.data.noMesin);
      setTglStnk(response.data.tglStnk && formatDate(response.data.tglStnk));
      setNoBpkb(response.data.noBpkb);
      setBpkbAN(response.data.bpkbAN);
      setBpkbAlamat(response.data.bpkbAlamat);

      setLinkMapsSurvey(response.data.linkMapsSurvey);

      // DATA REFERENSI
      setNamaRefRegister(response.data.namaRefRegister);
      setAlamatRefRegister(response.data.alamatRefRegister);
      setTeleponRefRegister(response.data.teleponRefRegister);
      setHubunganRefRegister(response.data.hubunganRefRegister);
      // setStatusPerkawinanRefRegister(response.data.statusPerkawinanRefRegister);
      setNamaRef2Register(response.data.namaRef2Register);
      setAlamatRef2Register(response.data.alamatRef2Register);
      setTeleponRef2Register(response.data.teleponRef2Register);
      setHubunganRef2Register(response.data.hubunganRef2Register);
      // setStatusPerkawinanRef2Register(
      //   response.data.statusPerkawinanRef2Register
      // );
      setNamaRef3Register(response.data.namaRef3Register);
      setAlamatRef3Register(response.data.alamatRef3Register);
      setTeleponRef3Register(response.data.teleponRef3Register);
      setHubunganRef3Register(response.data.hubunganRef3Register);
      // setStatusPerkawinanRef3Register(
      //   response.data.statusPerkawinanRef3Register
      // );

      // DATA PINJAMAN
      setHargaOtr(response.data.hargaOtr);
      setTglJtTempo(
        response.data.tglJtTempo && formatDate(response.data.tglJtTempo)
      );
      setTujuanPenggunaanDana(response.data.tujuanPenggunaanDana);
      setPendinganPengurusan(response.data.pendinganPengurusan);
      setKodeMarketing(
        `${response.data.marketing.kodeMarketing} - ${response.data.marketing.namaMarketing}`
      );
      setKodeSurveyor(
        `${response.data.surveyor.kodeSurveyor} - ${response.data.surveyor.namaSurveyor}`
      );

      setKeterangan(response.data.keterangan);

      setDenahLokasiSurvey(response.data.denahLokasiSurvey);
      setTtdSurvey(response.data.ttdSurvey);
      setNamaTtdSurvey(response.data.namaTtdSurvey);

      setStatusSurvey(response.data.statusSurvey);
      setTglRejectSurvey(
        response.data.tglRejectSurvey && new Date(response.data.tglRejectSurvey)
      );
      setAlasanRejectSurvey(response.data.alasanRejectSurvey);
      setAlasanPendingSurvey(response.data.alasanPendingSurvey);

      setStatusSurveyManager(response.data.statusSurveyManager);

      const findGambar = await axios.post(
        `${tempUrl}/surveyFidusiaGambarBySurveyFidusiaId`,
        {
          id: response.data.id,
          _id: user.id,
          token: user.token,
        }
      );
      setGambar(findGambar.data);
    }
  };

  const hapusSurveyFidusia = async (id) => {
    setLoading(true);
    try {
      if (ttdSurvey !== "") {
        // Hapus Gambar Lama
        let imageTtdSurvey = firebase.storage().refFromURL(ttdSurvey);
        imageTtdSurvey
          .delete()
          .then(function () {
            console.log("image ttdSurvey deleted");
          })
          .catch(function (error) {
            // An error occurred!
            console.log("an error occurred");
          });
      }

      if (denahLokasiSurvey !== "") {
        let imageDenahLokasiSurvey = firebase
          .storage()
          .refFromURL(denahLokasiSurvey);
        imageDenahLokasiSurvey
          .delete()
          .then(function () {
            console.log("image denahLokasiSurvey deleted");
          })
          .catch(function (error) {
            // An error occurred!
            console.log("an error occurred");
          });
      }

      await axios.post(`${tempUrl}/hapusSurveyFidusia/${id}`, {
        customerId,
        registerFidusiaId,
        _id: user.id,
        token: user.token,
      });
      setSearchTerm("");
      setNikCustomer("");
      setNoKkCustomer("");
      setCif("");
      setNamaCustomer("");
      setNamaPanggilanCustomer("");
      setTempatLahirCustomer("");
      setTanggalLahirCustomer("");
      setJenisKelaminCustomer("");
      setAgamaCustomer("");
      setNoTeleponCustomer("");
      setAlamatCustomer("");
      setKodeProvinsi("");
      setKodeKabupaten("");
      setKodeKecamatan("");
      setKodeKelurahan("");
      setKodePos("");
      setStatusPerkawinanCustomer("");
      setPekerjaanCustomer("");
      setKewarganegaraanCustomer("");

      setNamaPerusahaanCustomer("");
      setBidangUsahaCustomer("");
      setJabatanCustomer("");
      setAlamatPerusahaanCustomer("");
      setNoTeleponPerusahaanCustomer("");
      setLamaKerjaCustomer("");
      setGajiPekerjaanCustomer("");
      setPendapatanLainCustomer("");

      setNikPenjamin("");
      setNoKkPenjamin("");
      setNamaPenjamin("");
      setTempatLahirPenjamin("");
      setTanggalLahirPenjamin("");
      setJenisKelaminPenjamin("");
      setAgamaPenjamin("");
      setNoTeleponPenjamin("");
      setAlamatPenjamin("");
      setKodeProvinsiPenjamin("");
      setKodeKabupatenPenjamin("");
      setKodeKecamatanPenjamin("");
      setKodeKelurahanPenjamin("");
      setKodePosPenjamin("");
      setStatusPerkawinanPenjamin("");
      setNamaPerusahaanPenjamin("");
      setAlamatPerusahaanPenjamin("");
      setPekerjaanPenjamin("");
      setLamaKerjaPenjamin("");
      setKewarganegaraanPenjamin("");
      setHubunganPenjamin("");

      setAlamatSamaPenjamin("");
      setAlamatTTPenjamin("");
      setKodeProvinsiTTPenjamin("");
      setKodeKabupatenTTPenjamin("");
      setKodeKecamatanTTPenjamin("");
      setKodeKelurahanTTPenjamin("");
      setKodePosTTPenjamin("");

      setUangMuka("");
      setPinjamanAju("");
      setAngPerBulan("");
      setTenor("");

      // DATA KENDARAAN
      setMerk("");
      setTipe("");
      setTahun("");
      setWarna("");
      setIsi("");
      setNopol("");
      setNoRangka("");
      setNoMesin("");
      setTglStnk("");
      setNoBpkb("");
      setBpkbAN("");
      setBpkbAlamat("");

      setLinkMapsSurvey("");

      // DATA REFERENSI
      setNamaRefRegister("");
      setAlamatRefRegister("");
      setTeleponRefRegister("");
      setHubunganRefRegister("");
      // setStatusPerkawinanRefRegister("");
      setNamaRef2Register("");
      setAlamatRef2Register("");
      setTeleponRef2Register("");
      setHubunganRef2Register("");
      // setStatusPerkawinanRef2Register("");
      setNamaRef3Register("");
      setAlamatRef3Register("");
      setTeleponRef3Register("");
      setHubunganRef3Register("");
      // setStatusPerkawinanRef3Register("");

      // DATA PINJAMAN
      setHargaOtr("");
      setTglJtTempo("");
      setTujuanPenggunaanDana("");
      setPendinganPengurusan("");
      setKodeMarketing("");
      setKodeSurveyor("");

      setKeterangan("");

      setDenahLokasiSurvey("");
      setTtdSurvey("");
      setNamaTtdSurvey("");
      navigate("/surveyFidusia");
      setPreviewPdfFormulir(false);
      setOpen(false);
    } catch (error) {
      if (error.response.data.registerfidusia.message.includes("foreign key")) {
        alert(`${cif} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const batalSurveyFidusia = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/batalSurveyFidusia/${id}`, {
        customerId,
        kodeCabang: user.cabang.id,
        userIdUpdate: user.id,
        _id: user.id,
        token: user.token,
      });
      setIsReject(false);
      setIsPending(false);
      getSurveyFidusiaById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const accSurveyFidusia = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/accSurveyFidusia/${id}`, {
        customerId,
        kodeCabang: user.cabang.id,
        userIdUpdate: user.id,
        _id: user.id,
        token: user.token,
      });
      setIsReject(false);
      setIsPending(false);
      getSurveyFidusiaById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const rejectSurveyFidusia = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/rejectSurveyFidusia/${id}`, {
        customerId,
        tglRejectSurvey,
        alasanRejectSurvey,
        kodeCabang: user.cabang.id,
        userIdUpdate: user.id,
        _id: user.id,
        token: user.token,
      });
      setIsReject(false);
      setIsPending(false);
      getSurveyFidusiaById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const pendingSurveyFidusia = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/pendingSurveyFidusia/${id}`, {
        customerId,
        alasanPendingSurvey,
        kodeCabang: user.cabang.id,
        userIdUpdate: user.id,
        _id: user.id,
        token: user.token,
      });
      setIsReject(false);
      setIsPending(false);
      getSurveyFidusiaById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text(
      `${setting.namaPerusahaan} - ${setting.kabupatenPerusahaan}`,
      15,
      10
    );
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(14);
    doc.text(`Daftar Survey Fidusia`, 85, 30);
    doc.setFontSize(8);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      styles: {
        fontSize: 8,
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const downloadExcel = (data) => {
    const workSheet = XLSX.utils.json_to_sheet(data);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, `Daftar Survey`);
    // Buffer
    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    // Binary String
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    // Download
    XLSX.writeFile(workBook, `daftarSurvey.xlsx`);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "FormulirPermohonanAkadKredit",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container ref={ref}>
      <h3>Fidusia</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Survey Fidusia</h5>
      {!id && user.tipeUser !== "SURVEYOR" && (
        <>
          <Box sx={downloadButtons}>
            <ButtonGroup variant="outlined" color="secondary">
              <Button
                color="primary"
                startIcon={<SearchIcon />}
                onClick={() => {
                  getSurveyFidusias(true, false);
                  setPreviewPdf(!previewPdf);
                  setPreviewExcel(false);
                  setPreviewPdfFormulir(false);
                }}
              >
                PDF
              </Button>
              <Button
                color="secondary"
                startIcon={<SearchIcon />}
                onClick={() => {
                  getSurveyFidusias(false, true);
                  setPreviewExcel(!previewExcel);
                  setPreviewPdf(false);
                  setPreviewPdfFormulir(false);
                }}
              >
                Excel
              </Button>
            </ButtonGroup>
          </Box>
          <Box sx={buttonModifierContainer}>
            <ButtonModifier
              id={id}
              kode={id}
              addLink={`/surveyFidusia/tambahSurveyFidusia`}
              editLink={`/surveyFidusia/${id}/edit`}
              deleteUser={hapusSurveyFidusia}
              nameUser={cif}
            />
          </Box>
        </>
      )}
      {id && (
        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/surveyFidusia");
              setIsReject(false);
              setIsPending(false);
            }}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
        </Box>
      )}
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>Nama</th>
                <th>Alamat</th>
                <th>No. Telp</th>
              </tr>
            </thead>
            <tbody>
              {surveyFidusias.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.registerfidusia.customer.namaCustomer}</td>
                  <td>{user.registerfidusia.customer.alamatCustomer}</td>
                  <td>{user.registerfidusia.customer.noTeleponCustomer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {id && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => {
                getSurveyFidusias(true, false);
                setPreviewPdfFormulir(!previewPdfFormulir);
                setPreviewPdf(false);
                setPreviewExcel(false);
              }}
            >
              FORMULIR
            </Button>
          </ButtonGroup>
        </Box>
      )}
      {id && previewPdfFormulir && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={generatePDF}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} style={cetakContainer}>
            {/* Halaman 1 */}
            <div style={cetakPage}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={LogoPerusahaanSpFidusiaBlackAndWhite}
                  alt="LogoPerusahaanSpFidusiaBlackAndWhite"
                  style={{ width: "400px" }}
                />
              </div>
              <p style={cetakCenter}>FORMULIR PERMOHONAN AKAD KREDIT</p>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEMOHON</b>
                    </div>
                    <div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Lengkap (Sesuai KTP)</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Identitas</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Panggilan</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Tempat /Tanggal Lahir</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Status</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Jumlah Tanggungan</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Alamat KTP</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {namaCustomer && namaCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {nikCustomer && nikCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {namaPanggilanCustomer &&
                                  namaPanggilanCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {tempatLahirCustomer &&
                                  tempatLahirCustomer.slice(0, 24)}
                                , {tanggalLahirCustomer}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {statusPerkawinanCustomer &&
                                  statusPerkawinanCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {alamatCustomer && alamatCustomer.slice(0, 30)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatCustomer && alamatCustomer.slice(30, 30 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatCustomer &&
                            alamatCustomer.slice(30 + 65, 30 + 65 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Alamat Sekarang</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {alamatTTCustomer &&
                                  alamatTTCustomer.slice(0, 30)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatTTCustomer &&
                            alamatTTCustomer.slice(30, 30 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatTTCustomer &&
                            alamatTTCustomer.slice(30 + 65, 30 + 65 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Telp/HP 1</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Telp/HP 2</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Gadis Ibu Kandung</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {noTeleponCustomer &&
                                  noTeleponCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEKERJAAN</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Perusahaan/Usaha</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Bidang Usaha</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Bagian/Jabatan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Perusahaan/Usaha</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaPerusahaanCustomer &&
                                namaPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {bidangUsahaCustomer &&
                                bidangUsahaCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {jabatanCustomer && jabatanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPerusahaanCustomer &&
                                alamatPerusahaanCustomer.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatPerusahaanCustomer &&
                          alamatPerusahaanCustomer.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatPerusahaanCustomer &&
                          alamatPerusahaanCustomer.slice(30 + 65, 30 + 65 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp Perusahaan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Lama Kerja / Status</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPerusahaanCustomer}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {lamaKerjaCustomer &&
                                lamaKerjaCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            height: "104px",
                            border: "1px solid black",
                            paddingTop: "40px",
                          }}
                        >
                          <p style={textStyle}>Besaran Gaji dalam setahun</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"< 50 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"50 Juta - 75 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"75 Juta - 100 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"> 100 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pendapatan Lain</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Atasan Langsung</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Atasan</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {pendapatanLainCustomer.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}></p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pekerjaan/Alamat</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPerusahaanCustomer &&
                                noTeleponPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPerusahaanCustomer &&
                                alamatPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
                <div style={{ flex: 1, marginLeft: "20px" }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA KENDARAAN</b>
                    </div>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Merek</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Type</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Tahun</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Warna</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Polisi</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Rangka</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Mesin</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Masa Berlaku STNK</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Nama BPKB</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Alamat BPKB</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{merk && merk.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{tipe && tipe.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{tahun && tahun.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{warna && warna.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{nopol && nopol.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {noRangka && noRangka.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {noMesin && noMesin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{tglStnk}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {bpkbAN && bpkbAN.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {bpkbAlamat && bpkbAlamat.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}></p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}></p>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEMBIAYAAN / STRUKTUR KREDIT</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Harga OTR</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Uang Muka</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pokok Hutang</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Angsuran</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Jangka Waktu</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tanggal Jatuh Tempo</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tujuan Penggunaan Dana</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pendingan/Pengurusan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Sumber Order</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Surveyor</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {hargaOtr.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {uangMuka.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {pinjamanAju.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {angPerBulan.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tenor.toLocaleString("de-DE")} BULAN
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tglJtTempo && tglJtTempo.slice(0, 2)} SETIAP
                              BULAN
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tujuanPenggunaanDana &&
                                tujuanPenggunaanDana.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {pendinganPengurusan &&
                                pendinganPengurusan.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {kodeMarketing && kodeMarketing.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {kodeSurveyor && kodeSurveyor.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PENJAMIN</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Identitas</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Lengkap (Sesuai KTP)</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tempat /Tanggal Lahir</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Sekarang</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {nikPenjamin && nikPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaPenjamin && namaPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tempatLahirPenjamin &&
                                tempatLahirPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPenjamin &&
                                noTeleponPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPenjamin && alamatPenjamin.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPenjamin && alamatPenjamin.slice(30, 30 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPenjamin &&
                        alamatPenjamin.slice(30 + 65, 30 + 65 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Nama Perusahaan/Usaha</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Alamat Perusahaan/Usaha</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {namaPerusahaanPenjamin &&
                              namaPerusahaanPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {alamatPerusahaanPenjamin &&
                              alamatPerusahaanPenjamin.slice(0, 30)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPerusahaanPenjamin &&
                        alamatPerusahaanPenjamin.slice(30, 30 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPerusahaanPenjamin &&
                        alamatPerusahaanPenjamin.slice(30 + 65, 30 + 65 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Bagian/Jabatan</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Lama Kerja</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Hubungan Penjamin</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {pekerjaanPenjamin &&
                              pekerjaanPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {lamaKerjaPenjamin &&
                              lamaKerjaPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {hubunganPenjamin && hubunganPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div>
                  <div style={cetakTitle}>
                    <b>KETERANGAN LAIN</b>
                  </div>
                </div>
                <div style={{ border: "1px solid black", height: "120px" }}>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(0, 135)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(135, 270)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(270, 405)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(405, 540)}
                  </p>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div style={{ fontSize: "10px", fontWeight: "bold" }}>
                  <p style={textStyle}>
                    Catatan : Apabila Permohonan sudah disetujui Pemohon dan
                    Penjamin bersedia dan sanggup
                  </p>
                  <div style={{ marginLeft: "80px" }}>
                    <p style={textStyle}>
                      mentaati segala peraturan dan perjanjian yang telah
                      ditetapkan oleh perusahaan
                    </p>
                  </div>
                  <p style={textStyle}>* Coret yang tidak perlu</p>
                </div>
              </div>
            </div>

            {/* Halaman 2 */}
            <div style={cetakPage}>
              <div style={{ marginTop: "20px" }}>
                <p style={cetakCenter}>DENAH NASABAH & DATA REFERENSI</p>
              </div>

              <div style={{ display: "flex", marginTop: "20px" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRefRegister && namaRefRegister.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRefRegister &&
                                hubunganRefRegister.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRefRegister &&
                                statusPerkawinanRefRegister.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRefRegister &&
                                alamatRefRegister.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRefRegister &&
                          alamatRefRegister.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRefRegister &&
                                teleponRefRegister.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRef3Register &&
                                namaRef3Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRef3Register &&
                                hubunganRef3Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRef3Register &&
                                statusPerkawinanRef3Register.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRef3Register &&
                                alamatRef3Register.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRef3Register &&
                          alamatRef3Register.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRef3Register &&
                                teleponRef3Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
                <div style={{ flex: 1, marginLeft: "20px" }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRef2Register &&
                                namaRef2Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRef2Register &&
                                hubunganRef2Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRef2Register &&
                                statusPerkawinanRef2Register.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRef2Register &&
                                alamatRef2Register.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRef2Register &&
                          alamatRef2Register.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRef2Register &&
                                teleponRef2Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  marginTop: "40px",
                  marginBottom: "20px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <p style={textStyle}>{keteranganSurvey}</p>
              </div>

              <div style={{ marginLeft: "600px", fontWeight: "bold" }}>
                <div style={{ display: "flex" }}>
                  <p style={textStyle}>Batam,</p>
                  <div
                    style={{
                      marginLeft: "20px",
                      borderBottom: "1px solid black",
                      width: "160px",
                    }}
                  ></div>
                </div>
                <div style={{ marginLeft: "75px" }}>
                  <p style={textStyle}>Hormat Saya</p>
                </div>
                <div style={{ height: "100px", marginLeft: "75px" }}>
                  <img
                    src={ttdSurvey}
                    alt="Base64 Image"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "75px",
                    borderBottom: "1px solid black",
                    width: "160px",
                  }}
                >
                  <p style={textStyle}>Nama</p>
                </div>
                <div style={{ marginLeft: "75px" }}>
                  <p style={textStyle}>Pemohon</p>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div style={{ height: "300px" }}>
                  <img
                    src={denahLokasiSurvey}
                    alt="Base64 Image"
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {id && statusSurveyManager !== "ACC" && (
        <Box sx={buttonModifierContainer}>
          <ButtonGroup variant="contained">
            <Button
              color="warning"
              startIcon={<PanoramaIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => {
                navigate(`/surveyFidusia/${id}/editFoto`);
              }}
            >
              Ubah Foto
            </Button>
            <Button
              color="primary"
              startIcon={<EditIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => {
                navigate(`/surveyFidusia/${id}/edit`);
              }}
            >
              Ubah
            </Button>
            <Button
              color="error"
              startIcon={<DeleteOutlineIcon />}
              sx={{ textTransform: "none" }}
              onClick={handleClickOpen}
            >
              Hapus
            </Button>
          </ButtonGroup>
        </Box>
      )}
      {id && statusSurveyManager !== "ACC" && (
        <Box sx={buttonModifierContainer}>
          <ButtonGroup variant="contained">
            {(statusSurvey === "ACC" ||
              statusSurvey === "REJECT" ||
              statusSurvey === "PENDING") && (
              <Form onSubmit={batalSurveyFidusia}>
                <Button
                  color="primary"
                  sx={{ bgcolor: "primary.light", textTransform: "none" }}
                  type="submit"
                >
                  Batal
                </Button>
              </Form>
            )}
            {statusSurvey !== "ACC" && (
              <Form onSubmit={accSurveyFidusia}>
                <Button
                  color="success"
                  sx={{ bgcolor: "success.light", textTransform: "none" }}
                  type="submit"
                >
                  Acc
                </Button>
              </Form>
            )}
            {statusSurvey !== "REJECT" && (
              <Button
                color="error"
                sx={{ bgcolor: "error.light", textTransform: "none" }}
                // onClick={rejectSurveyFidusia}
                onClick={() => {
                  setIsReject(!isReject);
                  setIsPending(false);
                }}
              >
                Reject
              </Button>
            )}
            {statusSurvey !== "PENDING" && (
              <Button
                color="primary"
                sx={{ bgcolor: "primary.light", textTransform: "none" }}
                // onClick={pendingSurveyFidusia}
                onClick={() => {
                  setIsPending(!isPending);
                  setIsReject(false);
                }}
              >
                Pending
              </Button>
            )}
          </ButtonGroup>
        </Box>
      )}
      {id && isReject === true && (
        <div style={{ marginTop: "10px" }}>
          <Form noValidate onSubmit={rejectSurveyFidusia}>
            <Paper elevation={6} sx={mainContainer}>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Tanggal Reject <b style={colorRed}>*</b> :
                        </Form.Label>
                        <Col sm="7">
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            selected={tglRejectSurvey}
                            onChange={(e) => setTglRejectSurvey(e)}
                            customInput={
                              <TextField
                                error={
                                  error && tglRejectSurvey === null && true
                                }
                                helperText={
                                  error &&
                                  tglRejectSurvey === null &&
                                  "Tanggal Reject harus diisi!"
                                }
                                sx={{ width: "100%" }}
                                size="small"
                              />
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            Tanggal Reject harus diisi!
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Alasan Reject :
                        </Form.Label>
                        <Col sm="7">
                          <Form.Control
                            value={alasanRejectSurvey}
                            onChange={(e) =>
                              setAlasanRejectSurvey(e.target.value)
                            }
                            style={{ textTransform: "uppercase" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Alasan Reject harus diisi!
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Box sx={spacingTop}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Simpan
                    </Button>
                  </Box>
                </Box>
                <Box sx={[showDataWrapper, secondWrapper]}></Box>
              </Box>
            </Paper>
          </Form>
        </div>
      )}
      {id && isPending === true && (
        <div style={{ marginTop: "10px" }}>
          <Form noValidate onSubmit={pendingSurveyFidusia}>
            <Paper elevation={6} sx={mainContainer}>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Alasan Pending :
                        </Form.Label>
                        <Col sm="7">
                          <Form.Control
                            value={alasanPendingSurvey}
                            onChange={(e) =>
                              setAlasanPendingSurvey(e.target.value)
                            }
                            style={{ textTransform: "uppercase" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Alasan Pending harus diisi!
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Box sx={spacingTop}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Simpan
                    </Button>
                  </Box>
                </Box>
                <Box sx={[showDataWrapper, secondWrapper]}></Box>
              </Box>
            </Paper>
          </Form>
        </div>
      )}
      {!id && (
        <Row>
          <FormControl sx={{ marginTop: 1 }}>
            <FormLabel id="demo-controlled-radio-buttons-group">
              Filter
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              defaultValue="SEMUA"
              value={filter}
              onChange={handleChangeFilter}
            >
              <FormControlLabel
                value="SEMUA"
                control={<Radio />}
                label="Semua"
              />
              <FormControlLabel
                value="BELUM"
                control={<Radio />}
                label="Belum"
              />
              <FormControlLabel value="ACC" control={<Radio />} label="Acc" />
              <FormControlLabel
                value="REJECT"
                control={<Radio />}
                label="Reject"
              />
              <FormControlLabel
                value="PENDING"
                control={<Radio />}
                label="Pending"
              />
            </RadioGroup>
          </FormControl>
        </Row>
      )}
      {id && (
        <Container>
          <hr />
          {gambar.length !== 0 && (
            <Box sx={showDataContainer}>
              {gambar && (
                <Carousel breakPoints={breakPoints} sx={carouselStyle}>
                  {gambar &&
                    gambar.map((img, i) => (
                      <Card sx={oldImageCard} elevation={10}>
                        <CardActionArea disableRipple>
                          <CardHeader
                            title={`Gambar`}
                            subheader={`No. ${i + 1}`}
                          />
                          <CardMedia
                            component="img"
                            height="100%"
                            src={img.linkGambar}
                            alt="gambar"
                            sx={oldImageCardMedia}
                            onClick={() => {
                              window.open(
                                img.linkGambar,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          />
                        </CardActionArea>
                      </Card>
                    ))}
                </Carousel>
              )}
            </Box>
          )}

          <Form>
            {/* Survey */}
            <Card>
              <Card.Header>Survey</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Surveyor :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={kodeSurveyor} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Survey :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={statusSurvey} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    {alasanRejectSurvey.length > 0 && (
                      <>
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="5" style={textRight}>
                                Tanggal Reject :
                              </Form.Label>
                              <Col sm="7">
                                <DatePicker
                                  disabled
                                  dateFormat="dd/MM/yyyy"
                                  selected={tglRejectSurvey}
                                  customInput={
                                    <TextField
                                      disabled
                                      sx={{ width: "100%" }}
                                      size="small"
                                    />
                                  }
                                />
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="5" style={textRight}>
                                Alasan Reject :
                              </Form.Label>
                              <Col sm="7">
                                <Form.Control
                                  disabled
                                  value={alasanRejectSurvey}
                                />
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}
                    {alasanPendingSurvey.length > 0 && (
                      <Row>
                        <Col>
                          <Form.Group
                            as={Row}
                            className="mb-3"
                            controlId="formPlaintextPassword"
                          >
                            <Form.Label column sm="5" style={textRight}>
                              Alasan Pending :
                            </Form.Label>
                            <Col sm="7">
                              <Form.Control
                                disabled
                                value={alasanPendingSurvey}
                              />
                            </Col>
                          </Form.Group>
                        </Col>
                      </Row>
                    )}
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Customer */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Customer</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            CIF :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={cif} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            NIK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={nikCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. KK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={noKkCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={namaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Panggilan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={namaPanggilanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tempat Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={tempatLahirCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tgl. Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={tanggalLahirCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Jenis Kelamin :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={jenisKelaminCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Agama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={agamaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Telp / HP :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={noTeleponCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Perkawinan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={statusPerkawinanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pekerjaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={pekerjaanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kewarganegaraan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kewarganegaraanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Alamat (Identitas) */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Alamat (Identitas)</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKelurahan}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKecamatan}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKabupaten}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeProvinsi}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={kodePos} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Tempat Tinggal */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Tempat Tinggal</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatTTCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKelurahanTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKecamatanTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKabupatenTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeProvinsiTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={kodePosTT} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Lokasi Tempat Tinggal */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Lokasi Tempat Tinggal</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Link Map :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={linkMapsSurvey} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Pekerjaan */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Pekerjaan</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Perusahaan / Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={namaPerusahaanCustomer}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Bidang Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={bidangUsahaCustomer}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Jabatan / Posisi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={jabatanCustomer} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat Perusahaan / Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={alamatPerusahaanCustomer}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No .Telp Perusahaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={noTeleponPerusahaanCustomer}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Lama Kerja / Status :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={lamaKerjaCustomer} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Besaran Gaji / Bulan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={gajiPekerjaanCustomer.toLocaleString(
                                "de-DE"
                              )}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pendapatan Lain :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={pendapatanLainCustomer.toLocaleString(
                                "de-DE"
                              )}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Data Penjamin */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Penjamin</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            NIK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={nikPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. KK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={noKkPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              disabled
                              value={namaPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tempat Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={tempatLahirPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tgl. Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={tanggalLahirPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Jenis Kelamin :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={jenisKelaminPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Agama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={agamaPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Telp / HP :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={noTeleponPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Perkawinan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={statusPerkawinanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Perusahaan / Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={namaPerusahaanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat Perusahaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={alamatPerusahaanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pekerjaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={pekerjaanPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Lama Kerja / Status :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={lamaKerjaPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kewarganegaraan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kewarganegaraanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Hubungan dengan nasabah :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={hubunganPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Alamat (Identitas) Penjamin */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Alamat (Identitas) Penjamin</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={alamatPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKelurahanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKecamatanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKabupatenPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeProvinsiPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={kodePosPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Tempat Tinggal */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Tempat Tinggal</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              disabled
                              value={alamatTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKelurahanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKecamatanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKabupatenTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeProvinsiTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={kodePosTTPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Data Referensi */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Referensi</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Ref. Register :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={namaRefRegister} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Telepon Ref. Register :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={teleponRefRegister} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat Ref. Register :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={alamatRefRegister} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Hubungan dengan Nasabah :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={hubunganRefRegister}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Perkawinan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={statusPerkawinanRefRegister}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row> */}

                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Ref. Register 2 :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={namaRef2Register} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Telepon Ref. Register 2 :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={teleponRef2Register}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat Ref. Register 2 :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={alamatRef2Register} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Hubungan dengan Nasabah 2 :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={hubunganRef2Register}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Perkawinan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={statusPerkawinanRef2Register}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row> */}

                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Ref. Register 3 :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={namaRef3Register} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Telepon Ref. Register 3 :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={teleponRef3Register}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat Ref. Register 3 :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={alamatRef3Register} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Hubungan dengan Nasabah 3 :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={hubunganRef3Register}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Perkawinan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={statusPerkawinanRef3Register}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row> */}
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Data Pembiayaan / Struktur Pinjaman */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Pembiayaan / Struktur Pinjaman</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Harga OTR :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={hargaOtr.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Uang Muka :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={uangMuka.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pokok Hutang :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={pinjamanAju.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Angsuran / Bulan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={angPerBulan.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tenor :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={tenor.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tgl. Jt Tempo :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={tglJtTempo} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tujuan Penggunaan Dana :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={tujuanPenggunaanDana}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pendingan / Pengurusan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={pendinganPengurusan}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Sumber Order / Marketing :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={kodeMarketing} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Data Kendaraan */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Kendaraan</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Merk :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={merk} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tipe :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={tipe} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tahun :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={tahun} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Warna :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={warna} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            CC :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={isi} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Polisi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={nopol} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Rangka :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={noRangka} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Mesin :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={noMesin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tgl. STNK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={tglStnk} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Bpkb :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={noBpkb} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            BPKB A/N :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={bpkbAN} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat BPKB :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={bpkbAlamat} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Denah Lokasi */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Denah Lokasi</Card.Header>
              <Card.Body>
                <Box style={{ marginTop: "20px", height: "300px" }}>
                  <img
                    src={denahLokasiSurvey}
                    alt="Base64 Image"
                    style={{ maxWidth: "100%" }}
                  />
                </Box>
              </Card.Body>
            </Card>

            {/* Keterangan */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Keterangan</Card.Header>
              <Card.Body>
                <Box sx={keteranganContainer}>
                  <Form.Control
                    disabled
                    as="textarea"
                    rows={3}
                    value={keterangan}
                  />
                </Box>
                <Box sx={keteranganContainer}>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    disabled
                    value={keteranganSurvey}
                  />
                </Box>
                <Box sx={keteranganContainer}>
                  <Box sx={textFieldWrapper}></Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}>
                    <div>
                      <img
                        src={ttdSurvey}
                        alt="Base64 Image"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  </Box>
                </Box>
                <Box sx={keteranganContainer}>
                  <Box sx={textFieldWrapper}></Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">{"("}</InputGroup.Text>
                      <Form.Control disabled value={namaTtdSurvey} />
                      <InputGroup.Text id="basic-addon1">{")"}</InputGroup.Text>
                    </InputGroup>
                  </Box>
                </Box>
              </Card.Body>
            </Card>
          </Form>
        </Container>
      )}
      <hr />
      <Chip
        label="Acc"
        sx={{
          backgroundColor: Colors.green400,
          mr: 1,
        }}
      />
      <Chip
        label="Reject"
        sx={{
          backgroundColor: Colors.red400,
          mr: 1,
        }}
      />
      <Chip
        label="Pending"
        sx={{
          backgroundColor: Colors.blue100,
        }}
      />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableSurveyFidusia
          currentPosts={surveyFidusiasPagination}
          tipeUser={user.tipeUser}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Hapus Data`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Yakin ingin menghapus data ${cif}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => hapusSurveyFidusia(id)}>Ok</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TampilSurveyFidusia;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const keteranganContainer = {
  marginTop: "20px",
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const cetakPage = {
  // border: "1px solid black",
  // height: "1600px",
  height: "1380px",
};

const cetakContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const cetakCenter = {
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
  fontWeight: "bold",
  fontSize: "10px",
};

const cetakTitle = {
  padding: "5px",
  textAlign: "center",
  fontSize: "10px",
};

const formulirDataWrapper = {
  display: "flex",
  borderTop: "1px solid black",
  paddingBottom: "0px",
  fontSize: "10px",
};

const formulirDataAlamat = {
  display: "flex",
  paddingLeft: "10px",
  paddingRight: "10px",
  fontSize: "10px",
  height: "25px",
  border: "1px solid black",
};

const boxStyle = {
  border: "1px solid black",
  marginRight: "10px",
  height: "20px",
  width: "20px",
};

const textStyle = {
  marginBottom: 2,
};

const textStyleHidden = {
  marginBottom: 2,
  visibility: "hidden",
};

const formulirTextFieldContainer = {
  border: "1px solid black",
  padding: "2px",
};

const formulirTextValueContainer = {
  border: "1px solid black",
  padding: "2px",
  flex: 1,
};

const mainContainer = {
  padding: 3,
  borderRadius: "20px",
  margin: {
    sm: 0,
    md: 4,
  },
  marginTop: {
    xs: 4,
    md: 0,
  },
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const colorRed = {
  color: "red",
};

const spacingTop = {
  mt: 4,
};

const carouselStyle = {
  display: "flex",
  height: "400px",
};

const oldImageCard = {
  m: "auto",
  mt: 2,
  maxWidth: "500px",
  maxHeight: "500px",
  display: "flex",
  flexDirection: "column",
};

const oldImageCardMedia = {
  display: "flex",
  maxHeight: "150px",
};
